import { BrowserRouter, Route, Routes } from "react-router-dom";
import SigninForm from "../Components/auth/SigninForm";
import AuthLayout from "../layouts/AuthLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import ProtectedRoutes from "../navigation/ProtectedRoutes";
import PublicRoutes from "../navigation/PublicRoutes";
// import DashboardPage from "../Pages/DashboardPage";
import Message from "../Pages/Messages.jsx";
import NotFound from "../Pages/NotFound";
import UserPage from "../Pages/UserPage.jsx";
import UserManagementScreen from "../Pages/UserManagement/UserManagementScreen.jsx";
import TransactionManagementScreen from "../Pages/TransactionManagement/TransactionManagementScreen.jsx";
import Setting from "../Pages/Setting/index.jsx";
import CCQueryManagementScreen from "../Pages/CCQueryManagement/CCQueryManagementScreen.jsx";

const Navigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route element={<PublicRoutes />}>
          <Route path="/" element={<AuthLayout children={<SigninForm />} />} />
        </Route>

        {/* PROTECTED ROUTES */}
        <Route element={<ProtectedRoutes />}>
          {/* <Route
            path="/admin/dashboard"
            element={<DashboardLayout children={<DashboardPage />} />}
          />

         <Route
            path="/admin/dashboard"
            element={<DashboardLayout children={<DashboardPage />} />}
          />
          <Route
            path="/admin/orders"
            element={<DashboardLayout children={<OrderPage />} />}
          />
          <Route
            path="/admin/customers"
            element={<DashboardLayout children={<CustomerPage />} />}
          />
          <Route
            path="/admin/distributors"
            element={<DashboardLayout children={<DistributorsPage />} />}
          />
          <Route
            path="/admin/shopowners"
            element={<DashboardLayout children={<ShopOwnerPage />} />}
          />
          <Route
            path="/admin/riders"
            element={<DashboardLayout children={<RidersPage />} />}
          />

          <Route
            path="/admin/user"
            element={<DashboardLayout children={<UserPage />} />}
          />
          <Route
            path="/admin/change-password"
            element={<DashboardLayout children={<ChangePasswordPage />} />}
          />
          <Route
            path="/admin/page/:slug"
            element={<DashboardLayout children={<ContentManagementPage />} />}
          />
          <Route
            path="/admin/faqs"
            element={<DashboardLayout children={<Faqs />} />}
          />
          <Route
            path="/admin/report-types"
            element={<DashboardLayout children={<ReportTypes />} />}
          />
          <Route
            path="/admin/reports"
            element={<DashboardLayout children={<ReportsPage />} />}
          /> */}
          <Route
            path="/admin/user-management"
            element={<DashboardLayout children={<UserManagementScreen />} />}
          />
          <Route
            path="/admin/cc-query-management"
            element={<DashboardLayout children={<CCQueryManagementScreen />} />}
          />
          <Route
            path="/admin/transaction"
            element={<DashboardLayout children={<TransactionManagementScreen />} />}
          />
          <Route
            path="/admin/chat-support"
            element={<DashboardLayout children={<Message />} />}
          />
          <Route
            path="/admin/settings"
            element={<DashboardLayout children={<Setting />} />}
          />
        </Route>
        {/* KEEP IT AT THE END */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;
